import axios from 'axios';
import { env } from '@/config/env';
import { useAuthStore } from '@/store/useAuthStore';
import { getLanguageFromCookiesOrDefault } from '@/utils/utils';

const handleUnauthorized = async () => {
  const { resetAuth } = useAuthStore.getState(); // Access the Zustand store directly
  console.warn('Unauthorized request, possibly an invalid session.');
  await resetAuth(); // Call the resetAuth function to clear user data
};

// Creating an axios instance with base configuration
const axiosClient = axios.create({
  baseURL: env.apiURL, // Base URL for the API
  timeout: 60000, // Timeout for requests (60 seconds)
  withCredentials: true, // This option allows sending HTTP-only cookies
});

// Response interceptor
axiosClient.interceptors.response.use(
  (response) => {
    // Handle successful responses here
    return response;
  },
  (error) => {
    // Handling errors, e.g., when a session expires or user is unauthorized
    if (error.response) {
      if (error.response.status === 401) {
        // ? INFO: integration with refresh token
        /*
        console.warn('Unauthorized request, possibly an invalid session.');

        try {
          // Pokušaj osvežavanja tokena
          await axiosClient.get('/refresh', {
            withCredentials: true, // Omogućava slanje HTTPOnly cookies
          });

          // Ponovi originalni request nakon osvežavanja tokena
          return axiosClient.request(error.config);
        } catch (refreshError) {
          console.error('Token refresh failed, logging out user.', refreshError);
          handleUnauthorized(); // Npr. redirektuj korisnika na login stranicu
        }
        */

        // If the user is unauthorized (session token expired or invalid)
        console.warn('Unauthorized request, possibly an invalid session.');
        // Maybe redirect the user to the login page or refresh the session
        handleUnauthorized();
      }
    } else {
      console.error('Network Error:', error);
    }

    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// Request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    // ? INFO: Add additional headers if necessary (not needed for HTTP-only cookies)
    // ? INFO: For example, add custom headers for a specific route here if required
    config.headers['Accept-Language'] = getLanguageFromCookiesOrDefault();

    // ? INFO: axios cache clears
    // config.headers['Cache-Control'] = 'no-cache';
    // config.headers['Pragma'] = 'no-cache';
    // config.headers['Expires'] = '0';

    return config;
  },
  (error) => Promise.reject(error)
);

export { axiosClient };
